"use client";

import NextLink from "next/link";
import type { ComponentProps } from "react";
import { useUtmHref } from "@/lib/utm/hooks";

type LinkProps = Omit<ComponentProps<typeof NextLink>, "href"> & {
  href: string;
};

/** Drop-in `next/link` that keeps the visitor's UTM parameters across client-side navigation. */
export default function Link({ href, ...props }: LinkProps) {
  return <NextLink href={useUtmHref(href)} {...props} />;
}
